import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useShallow } from 'zustand/react/shallow'

import { basePath } from '@/router/paths.ts'
import { useAppointmentStore } from '@/store.ts'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireSlot?: boolean
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireSlot = true,
}) => {
  const navigate = useNavigate()
  const { selectedSlot } = useAppointmentStore(useShallow((state) => state))

  useEffect(() => {
    if (requireSlot && !selectedSlot) {
      navigate(basePath)
    }
  }, [selectedSlot, navigate, requireSlot])

  return <>{children}</>
}

export { ProtectedRoute }
